export default {
  errorStatement: 'Something went wrong.',
};
